import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface SuccessState {
    success: boolean;
    timeoutRef: number | null;
    triggerSuccess: (timeout?: number) => void;
    resetSuccess: () => void;
}

export const useSuccessStore = create<SuccessState>()(
    devtools(
        (set, get) => ({
            success: false,
            timeoutRef: null,

            triggerSuccess: (timeout = 1000) => {
                // Clear any existing timeout
                const currentTimeout = get().timeoutRef;
                if (currentTimeout !== null) {
                    clearTimeout(currentTimeout);
                }

                set({ success: true });

                // Set timeout to reset success after 1 second
                const timeoutRef = window.setTimeout(() => {
                    set({ success: false, timeoutRef: null });
                }, timeout);

                set({ timeoutRef });
            },

            resetSuccess: () => {
                const currentTimeout = get().timeoutRef;
                if (currentTimeout !== null) {
                    clearTimeout(currentTimeout);
                }
                set({ success: false, timeoutRef: null });
            },
        }),
        { name: 'success-store' }
    )
);
